import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type { GetWebhooksListResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  shortErrorMessage?: string
  children?: (data: GetWebhooksListResponse) => ReactElement
  onSuccess?: (webhooks: GetWebhooksListResponse) => void
}

const GetWebhooksRequest = ({
  children,
  onSuccess,
  shortErrorMessage
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/webhooks`

  const { requestParams } = useGetParamsWithSpaceId({})

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      params={requestParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetWebhooksRequest
